// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M2 5.5L4.75 2.75L7.5 5.5M4.75 2.75V13.25',
  'M8 8H14M8 10.63H12M8 13.25H10',
];
